import AgentFnMap from './agentFnMap';

export const POST_INSTRUCTION = 'sendAgentEvent';

export interface PscEventInstruction {
  instruction: typeof POST_INSTRUCTION;
  payload: {
    eventName: AgentFnMap;
    params: PscTrackerMandatoryVideoInfo | null;
    payloads: unknown[];
  };
}

export interface PscTrackerMandatoryVideoInfo {
  /**
   * Video-Type
   */
  cp1: string;
  /**
   * Video-ID
   */
  cp2: string;
  /**
   * Video-Title
   */
  cp3: string;
  /**
   * Video-Duration
   */
  cp4: string;

  /**
   * Language
   */
  cp13: string;
}
export interface PscTrackerOptionalVideoInfo {
  /**
   * Ad-ID
   */
  cp5: string;

  /**
   * Video-Part-ID
   */
  cp6: string;

  /**
   * Video-Part-Title
   */
  cp7: string;

  /**
   * Video-Part-Duration
   */
  cp8: string;

  /**
   * Airtime
   */
  cp9: string;

  /**
   * Web-Status
   */
  cp10: string;

  /**
   * Pay-Status
   */
  cp11: string;

  /**
   * Video-URL
   */
  cp12: string;

  /**
   * Program-Name
   */
  cp14: string;

  /**
   * TV-Channel
   */
  cp15: string;

  /**
   * Program-ID
   */
  cp16: string;
}

export type PscTrackerVideoInfo = PscTrackerMandatoryVideoInfo & Partial<PscTrackerOptionalVideoInfo>;
